import { render, staticRenderFns } from "./InsuranceCalculatorKasko.vue?vue&type=template&id=95829d64&"
import script from "./InsuranceCalculatorKasko.vue?vue&type=script&lang=js&"
export * from "./InsuranceCalculatorKasko.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports